export enum MemberActions {
  BOOKING_FLOW_ENTERED = "BOOKING_FLOW_ENTERED",
  BOOKING_CONSENT_VIEWED = "BOOKING_CONSENT_VIEWED",
  BOOKING_CONSENT_SKIPPED = "BOOKING_CONSENT_SKIPPED",
  BOOKING_GATING_VIEWED = "BOOKING_GATING_VIEWED",
  BOOKING_GATING_SKIPPED = "BOOKING_GATING_SKIPPED",
  BOOKING_GATING_RESULT = "BOOKING_GATING_RESULT",
  BOOKING_SCHEDULING_VIEWED = "BOOKING_SCHEDULING_VIEWED",
  BOOKING_NO_DATES = "BOOKING_NO_DATES",
  BOOKING_SUBMITTED = "BOOKING_SUBMITTED",
  BOOKING_SUCCESS = "BOOKING_SUCCESS",
  BOOKING_PREPARE_FOR_VISIT_CLICKED = "BOOKING_PREPARE_FOR_VISIT_CLICKED",
  APPOINTMENTS_PAGE_VIEWED = "APPOINTMENTS_PAGE_VIEWED",
  APPOINTMENTS_PREPARE_FOR_VISIT_CLICKED = "APPOINTMENTS_PREPARE_FOR_VISIT_CLICKED",
  JOIN_CLICKED = "JOIN_CLICKED",
  CANCEL_STARTED = "CANCEL_STARTED",
  CANCEL_CONFIRMED = "CANCEL_CONFIRMED",
  CANCEL_SUCCEEDED = "CANCEL_SUCCEEDED",
  CANCEL_FAILED = "CANCEL_FAILED",
  SEND_A_MESSAGE_CLICKED = "SEND_A_MESSAGE_CLICKED",
  PREPARE_FOR_VISIT_VIEWED = "PREPARE_FOR_VISIT_VIEWED",
  ID_UPLOAD_FRONT_ADDED = "ID_UPLOAD_FRONT_ADDED",
  ID_UPLOAD_BACK_ADDED = "ID_UPLOAD_BACK_ADDED",
  ID_UPLOAD_COMPLETED = "ID_UPLOAD_COMPLETED",
  PRE_VISIT_FORM_VIEWED = "PRE_VISIT_FORM_VIEWED",
  PRE_VISIT_FORM_STARTED = "PRE_VISIT_FORM_STARTED",
  PRE_VISIT_FORM_SUBMISSION_ATTEMPTED = "PRE_VISIT_FORM_SUBMISSION_ATTEMPTED",
  PRE_VISIT_FORM_SUBMISSION_SUCCEEDED = "PRE_VISIT_FORM_SUBMISSION_SUCCEEDED",
  PHONE_NUMBER_COLLECTION_MODAL_VIEWED = "PHONE_NUMBER_COLLECTION_MODAL_VIEWED",
  PHONE_NUMBER_COLLECTION_MODAL_DISMISSED = "PHONE_NUMBER_COLLECTION_MODAL_DISMISSED",
  REGISTRATION_WELCOME_CONTINUE = "REGISTRATION_WELCOME_CONTINUE",
  SDOH_FINDHELP_LINK_CLICKED = "SDOH_FINDHELP_LINK_CLICKED",
  DIGITAL_BENEFITS_GUIDE_VIEWED = "DIGITAL_BENEFITS_GUIDE_VIEWED",
  CP_MENU_ITEM_CLICKED = "CP_MENU_ITEM_CLICKED",
  CARROT_ACADEMY_VIDEO_VIEWED = "CARROT_ACADEMY_VIDEO_VIEWED",
  CARROT_ACADEMY_ARTICLE_VIEWED = "CARROT_ACADEMY_ARTICLE_VIEWED",
  CARROT_ACADEMY_GROUP_VIEWED = "CARROT_ACADEMY_GROUP_VIEWED",
  CARROT_ACADEMY_GUIDE_LANDING_PAGE_VIEWED = "CARROT_ACADEMY_GUIDE_LANDING_PAGE_VIEWED",
  CARROT_ACADEMY_GUIDE_OPENED = "CARROT_ACADEMY_GUIDE_OPENED",
  CARROT_ACADEMY_GUIDE_COMPLETED = "CARROT_ACADEMY_GUIDE_COMPLETED",
  ART_CONSENT_FORM_VIEWED_REGISTRATION = "ART_CONSENT_FORM_VIEWED_REGISTRATION",
  PROVIDER_CARD_INTERACTION_PHONE_NUMBER = "PROVIDER_CARD_INTERACTION_PHONE_NUMBER",
  PROVIDER_CARD_INTERACTION_EMAIL = "PROVIDER_CARD_INTERACTION_EMAIL",
  PROVIDER_CARD_INTERACTION_DIRECTIONS = "PROVIDER_CARD_INTERACTION_DIRECTIONS",
  PROVIDER_CARD_INTERACTION_WEBSITE = "PROVIDER_CARD_INTERACTION_WEBSITE",
  PROVIDER_CARD_INTERACTION_REQUEST_APPOINTMENT = "PROVIDER_CARD_INTERACTION_REQUEST_APPOINTMENT",
  PROVIDER_CARD_INTERACTION_ORIGIN_LEARN_MORE = "PROVIDER_CARD_INTERACTION_ORIGIN_LEARN_MORE",
  PROVIDER_CARD_INTERACTION_ORIGIN_GET_STARTED = "PROVIDER_CARD_INTERACTION_ORIGIN_GET_STARTED",
  CARROT_MATCH_RESULT_INTERACTION_PHONE_NUMBER = "CARROT_MATCH_RESULT_INTERACTION_PHONE_NUMBER",
  CARROT_MATCH_RESULT_INTERACTION_DIRECTIONS = "CARROT_MATCH_RESULT_INTERACTION_DIRECTIONS",
  CARROT_MATCH_RESULT_INTERACTION_WEBSITE = "CARROT_MATCH_RESULT_INTERACTION_WEBSITE",
  CARROT_MATCH_RESULT_INTERACTION_REQUEST_APPOINTMENT = "CARROT_MATCH_RESULT_INTERACTION_REQUEST_APPOINTMENT",
  REQUEST_APPOINTMENT_FORM_SUBMISSION = "REQUEST_APPOINTMENT_FORM_SUBMISSION",
  PROVIDER_FINDER_TYPE_SEARCH_RESULT_VIEWED = "PROVIDER_FINDER_TYPE_SEARCH_RESULT_VIEWED",
  PROVIDER_FINDER_KEYWORD_SEARCH_RESULT_VIEWED = "PROVIDER_FINDER_KEYWORD_SEARCH_RESULT_VIEWED",
  PROVIDER_FINDER_EMPTY_STATE_VIEWED = "PROVIDER_FINDER_EMPTY_STATE_VIEWED",
  PROVIDER_FINDER_RECOMMEND_A_DOULA_OPENED = "PROVIDER_FINDER_RECOMMEND_A_DOULA_OPENED",
  PROVIDER_FINDER_RECOMMENDATION_FORM_VIEWED = "PROVIDER_FINDER_RECOMMENDATION_FORM_VIEWED",
  PROVIDER_FINDER_RECOMMENDATION_FORM_SUBMITTED = "PROVIDER_FINDER_RECOMMENDATION_FORM_SUBMITTED",
  CHECK_IN_DIALOG_VIEWED = "CHECK_IN_DIALOG_VIEWED",
  CHECK_IN_ARE_YOU_STILL_IN_THIS_PHASE_VIEWED = "CHECK_IN_ARE_YOU_STILL_IN_THIS_PHASE_VIEWED",
  CHECK_IN_WHERE_ARE_YOU_IN_JOURNEY_NOW_VIEWED = "CHECK_IN_WHERE_ARE_YOU_IN_JOURNEY_NOW_VIEWED",
  CHECK_IN_PRESERVATION_VIEWED = "CHECK_IN_PRESERVATION_VIEWED",
  CHECK_IN_WHAT_KIND_OF_JOURNEY_VIEWED = "CHECK_IN_WHAT_KIND_OF_JOURNEY_VIEWED",
  CHECK_IN_MOST_HELPFUL_VIEWED = "CHECK_IN_WHAT_WOULD_BE_MOST_HELPFUL_VIEWED",
  CHECK_IN_GOAL_TIMEFRAME_VIEWED = "CHECK_IN_GOAL_TIMEFRAME_VIEWED",
  CHECK_IN_DO_ANY_APPLY_VIEWED = "CHECK_IN_DO_ANY_APPLY_VIEWED",
  CHECK_IN_PARTNER_DO_ANY_APPLY_VIEWED = "CHECK_IN_PARTNER_DO_ANY_APPLY_VIEWED",
  CHECK_IN_ANYTHING_ELSE_VIEWED = "CHECK_IN_ANYTHING_ELSE_VIEWED",
  CHECK_IN_ANYTHING_ELSE_SENSITIVE_SCENARIO_VIEWED = "CHECK_IN_ANYTHING_ELSE_SENSITIVE_SCENARIO_VIEWED",
  CHECK_IN_MESSAGE_WONDERFUL_VIEWED = "CHECK_IN_MESSAGE_WONDERFUL_VIEWED",
  HOMEPAGE_GET_CARROT_PLAN_CLICKED = "HOMEPAGE_GET_CARROT_PLAN_CLICKED",
  HOMEPAGE_CARROT_COMPANION_REPLY_CLICKED = "HOMEPAGE_CARROT_COMPANION_REPLY_CLICKED",
  HOMEPAGE_CARROT_COMPANION_DISMISS_CLICKED = "HOMEPAGE_CARROT_COMPANION_DISMISS_CLICKED",
  HOMEPAGE_CARROT_COMPANION_MESSAGE_CLICKED = "HOMEPAGE_CARROT_COMPANION_MESSAGE_CLICKED",
  CARE_TEAM_GET_CARROT_PLAN_CLICKED = "CARE_TEAM_GET_CARROT_PLAN_CLICKED",
  CARE_TEAM_MESSAGE_CARE_TEAM_CLICKED = "CARE_TEAM_MESSAGE_CARE_TEAM_CLICKED",
  CARE_TEAM_CALL_US_CLICKED = "CARE_TEAM_CALL_US_CLICKED",
  CARE_TEAM_FIND_SPECIALIST_CLICKED = "CARE_TEAM_FIND_SPECIALIST_CLICKED",
  CARE_TEAM_SPECIALIST_BOOK_AGAIN_CLICKED = "CARE_TEAM_SPECIALIST_BOOK_AGAIN_CLICKED",
  CARE_TEAM_OTHER_CONTACT_CALL_CLICKED = "CARE_TEAM_OTHER_CONTACT_CALL_CLICKED",
  BOOK_AGAIN_CHAT_TYPE_TILE_CLICKED = "BOOK_AGAIN_CHAT_TYPE_TILE_CLICKED",
  BOOK_AGAIN_FIND_A_SPECIALIST_BUTTON_CLICKED = "BOOK_AGAIN_FIND_A_SPECIALIST_BUTTON_CLICKED",
  PROVIDER_FINDER_DOULA_SERVICE_FILTER_SEARCHED = "PROVIDER_FINDER_DOULA_SERVICE_FILTER_SEARCHED",
  PROVIDER_FINDER_DOULA_RECOMMENDED = "PROVIDER_FINDER_DOULA_RECOMMENDED",
  DOULA_RECOMMENDATION_SUBITTED_SUCCESSFULLY = "DOULA_RECOMMENDATION_SUBITTED_SUCCESSFULLY",
  DOULA_RECOMMENDATION_APPROVED_NOT_COMPLETE_FOR_PRODUCT = "DOULA_RECOMMENDATION_APPROVED_NOT_COMPLETE_FOR_PRODUCT",
  DOULA_RECOMMENDATION_APPROVED = "DOULA_RECOMMENDATION_APPROVED",
  DOULA_RECOMMENDATION_PENDING = "DOULA_RECOMMENDATION_PENDING",
  DOULA_RECOMMENDATION_NOT_APPROVED = "DOULA_RECOMMENDATION_NOT_APPROVED",
  PROVIDER_FINDER_CCOE_FILTER_TOGGLED = "PROVIDER_FINDER_CCOE_FILTER_TOGGLED",
  PROVIDER_FINDER_CARROT_PARTNER_FILTER_TOGGLED = "PROVIDER_FINDER_CARROT_PARTNER_FILTER_TOGGLED",
  PROVIDER_FINDER_DIRECT_PAY_FILTER_TOGGLED = "PROVIDER_FINDER_DIRECT_PAY_FILTER_TOGGLED",
  PROVIDER_FINDER_VIRTUAL_FILTER_TOGGLED = "PROVIDER_FINDER_VIRTUAL_FILTER_TOGGLED",
  PROVIDER_FINDER_NETWORK_FILTER_TOGGLED = "PROVIDER_FINDER_NETWORK_FILTER_TOGGLED",
  TTC_SPECIALIST_CATEGORY_SELECTED = "TTC_SPECIALIST_CATEGORY_SELECTED",
  CARROT_COLLECTIVE_VIEWED_PAGE = "CARROT_COLLECTIVE_VIEWED_PAGE",
  CARROT_COLLECTIVE_CLICKED_LEARN_MORE = "CARROT_COLLECTIVE_CLICKED_LEARN_MORE",
  CARROT_COLLECTIVE_CLICKED_LEARN_MORE_ABOUT_COVERAGE = "CARROT_COLLECTIVE_CLICKED_LEARN_MORE_ABOUT_COVERAGE",
  CARROT_COLLECTIVE_CLICKED_CLAIM_DISCOUNT = "CARROT_COLLECTIVE_CLICKED_CLAIM_DISCOUNT",
  PAGE_VIEWED = "PAGE_VIEWED",
  BUTTON_CLICKED = "BUTTON_CLICKED"
}
